import { assignJob, getFreePopulation, MAX_MINTERS } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireMinterAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.mint.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_MINTERS * settlement.buildings.mint.qty;
    if (settlement.jobs.minters >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'minters')) return false;
    settlement.production.mint.progress.push(0);
    return true;
};
